import { getClientDomain } from './env/apiDomain'

const ANONYMOUS_PATH_SEGMENT = 'ext-public'

// determines if the current path allows anonymous access (path must begin with /ext-public/)
export default function isCurrentPathForAnonymousAccess(): boolean {
  const clientDomain = getClientDomain()
  const segments = window.location.pathname.split('/')

  // the anonymous segment should be in the first segment (if not clients.purecars.com) or 3rd segment (if clients.purecars.com)
  return window.location.origin === clientDomain
    ? segments.length > 3 && segments[3] === ANONYMOUS_PATH_SEGMENT
    : segments.length > 1 && segments[1] === ANONYMOUS_PATH_SEGMENT
}
